import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled from '@emotion/styled'

const NavText = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`

const Separator = styled.div`
  display: inline-block;
  border-radius: 50%;
  width: 6px;
  height: 6px;
`

const NavItem = styled.div`
  display: inline-block;
  font-family: 'Nunito', sans-serif;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 5px;
  text-align: center;
`

const Container = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  width: 100%;
  max-width: 960px;
  margin: auto;
  color: ${props => props.color};

  a:link, a:visited {
    text-decoration: none;
    color: ${props => props.color};
  }

  ${NavItem} {
    color: ${props => props.color};
  }

  ${Separator} {
    background: ${props => props.color};
  }
`

const LogoContainer = styled.div`
  margin: 0 10%;
`

const Navigation = ({logo: Logo, color, id}) => (
  <Container color={color}>
    <NavText>
    <NavItem><Link to="/services">Services</Link></NavItem>
    <Separator />
    <NavItem><Link to="/portfolio">Portfolio</Link></NavItem>
    </NavText>
    {
      Logo
      ? (<LogoContainer>
          <Link to="/">
            <Logo />
          </Link>
        </LogoContainer>)
      : <Separator />
    }
    <NavText>
    <NavItem><Link to="/about">About</Link></NavItem>
    <Separator />
    <NavItem><a href="#reach-out">Contact</a></NavItem>
    </NavText>
  </Container>
)

Navigation.defaultProps = {
  color: '#184233',
}

export default Navigation
